import UploadReports from "./uploadReports";

export default UploadReports;
